import BaseModel from '@/app-core/lib/data/model/BaseModel'
import ContactValidator from '@/app-core/api/validations/contact/ContactValidator'
import ContactResource from '@/app-core/api/resources/contact/ContactResource'
import API from '@/app-core/api/Api'

export default class ContactModel extends BaseModel {
  constructor(payload = {}, resource = ContactResource, validator = ContactValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */

  async Send() {
    return await API.Resource.Contact.Send(this.clone())
  }
}
